import { handleAccessDeniedMessage } from './handleAccessDeniedMessage'
import { ErrorMessageType } from './types'

export const getErrorMessage = (
  status: number,
  networkErrorMessage: string,
  title: string,
  customMessage?: Record<number, ErrorMessageType>,
): ErrorMessageType => {
  const messages: Record<number, ErrorMessageType> = {
    401: handleAccessDeniedMessage(networkErrorMessage, title),
    403: {
      message: "You don't have permission to perform this requested action. Please contact your administrator.",
      title: title || 'Permission Denied',
    },
    404: handleAccessDeniedMessage(networkErrorMessage, title),
    409: {
      message: 'Something went wrong. Please try again or contact support.',
      title,
    },
    422: {
      message: 'Something went wrong. Please try again or contact support.',
      title,
    },
    500: {
      message: 'Something went wrong. Please try again or contact support.',
      title,
    },
    502: {
      message: 'Something went wrong. Please try again or contact support.',
      title,
    },
    504: {
      message: 'Something went wrong. Please try again or contact support.',
      title,
    },
    0: {
      message: 'Something went wrong. Please try again or contact support.',
      title,
    },
  }

  // Return the specific message or a generic default
  return (customMessage || messages)[status] || messages[0]
}
